export const BASE_URL = import.meta.env.VITE_APP_BASE_URL;
export const LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL;
export const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL;
export const IS_PRODUCTION = import.meta.env.VITE_IS_PRODUCTION;

export const API_BASE_URL = import.meta.env.VITE_PUBLIC_URL;
export const USER_POOL_ID = import.meta.env.VITE_USER_POOL_ID;
export const CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
export const AWS_REGION = import.meta.env.VITE_AWS_REGION;

export const AUTHORITY_URL = import.meta.env.VITE_AUTHORITY;
export const REDIRECT_URI = import.meta.env.VITE_REDIRECT_URI;
export const RESPONSE_TYPE = import.meta.env.VITE_RESPONSE_TYPE;

///////////////////////////////////////////////////////////
////////////// Modifications by Modular Team //////////////
///////////////////////////////////////////////////////////

// This is meant so Modular Team can test the client code against a localhost if they choose to
const useLocalhost = localStorage.getItem('useLocalhost') === 'true';

export const CLIENT_CREATE_PROJECT_API = useLocalhost
    ? 'http://localhost:8000/init'
    : import.meta.env.VITE_CLIENT_CREATE_PROJECT_API;

export const CLIENT_SIDE_SAVE_API = useLocalhost
    ? 'http://localhost:8000/submit'
    : import.meta.env.VITE_CLIENT_SIDE_SAVE_API;

///////////////////////////////////////////////////////////
/////////////////////////// end ///////////////////////////
///////////////////////////////////////////////////////////

export const LAYOUT_API_ENDPOINT = import.meta.env.VITE_LAYOUT_API_ENDPOINT;

export const SERVER_BASE_URL = import.meta.env.VITE_SERVER_URL;
export const PREDICT_API = import.meta.env.VITE_PREDICT_API;

// Helper to get the callback URI for OAuth
export const getCallbackUri = () => {
    return `${window.location.origin}/auth/callback`;
};
